"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const shared_utils_1 = require("@vue-devtools/shared-utils");
Object.defineProperty(exports, "hook", { get: function() {
  return shared_utils_1.target.__VUE_DEVTOOLS_GLOBAL_HOOK__
} });
//# sourceMappingURL=global-hook.js.map